import { mapState } from 'pinia'

import { feedSections } from 'src/components/navigation/feeds.js'
import {
  filterNavigation,
  getBookmarkEntries,
  getFollowedTagEntries,
  getListEntries,
} from 'src/components/navigation/filter.js'
import { TIMELINES } from 'src/components/navigation/navigation.js'
import NavigationEntry from 'src/components/navigation/navigation_entry.vue'
import TimelineSettingsMenu from 'src/components/timeline_settings_menu/timeline_settings_menu.vue'

import { useBookmarkFoldersStore } from 'src/stores/bookmark_folders.js'
import { useFollowedTagsStore } from 'src/stores/followed_tags.js'
import { useInstanceCapabilitiesStore } from 'src/stores/instance_capabilities.js'
import { useListsStore } from 'src/stores/lists.js'
import { useUsersStore } from 'src/stores/users.js'

// Every feed, in groups: the one place to switch feeds
export default {
  components: { NavigationEntry, TimelineSettingsMenu },
  props: {
    // the timeline settings as a last row (the phone: it has no header row)
    settings: Boolean,
  },
  created() {
    if (this.currentUser) useFollowedTagsStore().ensureLoaded()
  },
  computed: {
    ...mapState(useListsStore, { lists: getListEntries }),
    ...mapState(useBookmarkFoldersStore, { bookmarks: getBookmarkEntries }),
    ...mapState(useFollowedTagsStore, {
      tags: (store) => getFollowedTagEntries(store.tags),
    }),
    ...mapState(useInstanceCapabilitiesStore, [
      'pleromaBookmarkFoldersAvailable',
    ]),
    ...mapState(useUsersStore, ['currentUser']),
    sections() {
      return feedSections({
        timelines: filterNavigation(
          Object.entries(TIMELINES).map(([name, item]) => ({ ...item, name })),
        ),
        lists: this.lists,
        tags: this.tags,
        bookmarks: this.bookmarks,
        loggedIn: !!this.currentUser,
        bookmarkFolders: this.pleromaBookmarkFoldersAvailable,
      })
    },
  },
}
